module.exports = (__webpack_require__(14))(84);


//////////////////
// WEBPACK FOOTER
// delegated ../../third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/js/modules/infragistics.datasource.js from dll-reference obpa_dependencies
// module id = 416
// module chunks = 0